module.exports = __webpack_public_path__ + "img/teatro.51b4567c.png";